module.exports = __webpack_public_path__ + "img/Dantam Bridal 21.96f36ece.jpg";